import React from 'react'
import styled from 'styled-components'

const StyledParagraph = styled.p`
  -webkit-line-clamp: ${({ displayLines = 2 }) => displayLines};
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;
`

const StyledDiv = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
`

const ClampedCard = ({ title, description, displayLines }) => (
  <>
    <StyledDiv className="font-weight-bold" title={title}>
      {title}
    </StyledDiv>
    <StyledParagraph className="placeholder mb-0" displayLines={displayLines}>
      {description}
    </StyledParagraph>
  </>
)

export default ClampedCard
